import { render, staticRenderFns } from "./UserInfoTasksCard.vue?vue&type=template&id=292503c4&scoped=true&"
import script from "./UserInfoTasksCard.vue?vue&type=script&lang=js&"
export * from "./UserInfoTasksCard.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoTasksCard.vue?vue&type=style&index=0&id=292503c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292503c4",
  null
  
)

export default component.exports